const getMailchimpConfig = () => {
  const apiKey = process.env.REACT_APP_MAILCHIMP_API_KEY;
  const audienceId = process.env.REACT_APP_MAILCHIMP_AUDIENCE_ID;

  if (!apiKey || !audienceId) {
    return null;
  }

  const datacenter = apiKey.split('-')[1];

  if (!datacenter) {
    throw new Error('Mailchimp API key is missing its datacenter suffix.');
  }

  return {
    url: `https://${datacenter}.api.mailchimp.com/3.0/lists/${audienceId}/members`,
    apiKey,
  };
};

export async function subscribeToNewsletter(email) {
  const trimmedEmail = String(email || '').trim();

  if (!trimmedEmail) {
    throw new Error('Please enter a valid email address.');
  }

  const customEndpoint = process.env.REACT_APP_NEWSLETTER_ENDPOINT;

  if (customEndpoint) {
    const response = await fetch(customEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: trimmedEmail }),
    });

    if (!response.ok) {
      let message = 'We could not subscribe you right now. Please try again.';

      try {
        const payload = await response.json();
        if (payload?.message) {
          message = payload.message;
        }
      } catch (error) {
        // Ignore JSON parsing errors and keep the fallback message.
      }

      throw new Error(message);
    }

    return response.json ? await response.json() : null;
  }

  const mailchimpConfig = getMailchimpConfig();

  if (!mailchimpConfig) {
    throw new Error(
      'Newsletter provider is not configured. Set REACT_APP_NEWSLETTER_ENDPOINT or Mailchimp env vars.'
    );
  }

  const response = await fetch(mailchimpConfig.url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Basic ${btoa(`anystring:${mailchimpConfig.apiKey}`)}`,
    },
    body: JSON.stringify({
      email_address: trimmedEmail,
      status: 'subscribed',
      merge_fields: {
        FNAME: '',
        LNAME: '',
      },
    }),
  });

  if (!response.ok) {
    let message = 'We could not subscribe you right now. Please try again.';

    try {
      const payload = await response.json();
      if (payload?.detail) {
        message = payload.detail;
      } else if (payload?.errors?.length) {
        message = payload.errors[0].message || message;
      }
    } catch (error) {
      // Ignore JSON parsing errors and keep the fallback message.
    }

    throw new Error(message);
  }

  return response.json ? await response.json() : null;
}
